<template>
  <v-btn class="sso-button-microsoft py-4" block outlined :elevation="0" @click="logInSso()" :loading="loading" :disabled="disabled">
    <img class="sso-picture-button mr-4" src="../assets/icon/logo-microsoft-without-text.png"/>
    <div>S'identifier avec microsoft</div>
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue'
import { AuthenticationResult } from '@azure/msal-browser'
import msalInstance from '@/msal-config'
import { logException } from '@/utils/log'
import { isSafari } from '@/utils/brower'

export default Vue.extend({
  props: ['loading', 'disabled'],
  name: 'SsoButton',
  methods: {
    logInSso(): void {
      this.$emit('click')
      if (isSafari()) {
        msalInstance
          .loginRedirect({
            scopes: ['User.Read'],
            redirectUri: `${process.env.VUE_APP_URL_SSO}/login`,
          })
      } else {
        msalInstance
          .loginPopup({
            scopes: ['User.Read'],
          })
          .then((responseSso: AuthenticationResult) => {
            this.$emit('login-sso', responseSso)
          })
          .catch((error) => {
            this.$emit('error')
            logException(error)
          })
      }
    },
  },
})
</script>

<style scoped>
.sso-button-microsoft {
  display: inline-flex;
  background: rgba(255, 255, 255, 0.25);
  margin-top: 10px ;
}

.sso-picture-button {
  height: 25px;
  width: 25px;
}
</style>
